import { useEffect, useState } from "react";
import { TRANSITION_DURATION } from "../constants";
import { layers, intialLayer } from "../layers";
import Transition from "./Transition";

const Controls = ({ activeLayer, setActiveLayer }) => {
  const [transition, setTransition] = useState(intialLayer);
  const [showTransition, setShowTransition] = useState(true);

  const indexCurrent = layers.findIndex((layer) => layer === activeLayer);
  const indexNext = indexCurrent + 1;
  const indexPrevious = indexCurrent - 1;
  const hasNext = indexNext < layers.length;
  const hasPrevious = indexPrevious >= 0;

  useEffect(() => {
    setTimeout(() => {
      setShowTransition(false);
    }, TRANSITION_DURATION * 2);
  }, []);

  const startTransition = (index) => {
    setTransition(layers[index]);
    setShowTransition(true);
    setTimeout(() => {
      setActiveLayer(layers[index]);
    }, TRANSITION_DURATION);
    setTimeout(() => {
      setShowTransition(false);
    }, TRANSITION_DURATION * 2);
  };

  return (
    <>
      <Transition show={showTransition} color={transition.color}>
        {transition.text}
      </Transition>
      <div className="controls">
        <button
          onClick={() => hasNext && startTransition(indexNext)}
          disabled={!hasNext}
        >
          +
        </button>
        <button
          onClick={() => hasPrevious && startTransition(indexPrevious)}
          disabled={!hasPrevious}
        >
          ⁠–
        </button>
      </div>
    </>
  );
};

export default Controls;
